var _defs, _g, _g2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableComponent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 98 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 { fill: none; }\n      .st2 { fill: #828282; }\n      .st3 { isolation: isolate; }\n      .st4 { fill: #fff; }\n      .st1 { stroke: #707070; }\n    "))), /*#__PURE__*/React.createElement("g", {
    id: "Group_table"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_bg"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    width: 98,
    height: 102,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 0.5,
    y: 0.5,
    width: 97,
    height: 101,
    rx: 3.5,
    ry: 3.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Table_label",
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.2,86v-7.1h4.6v1h-3.4v2h2.8v1h-2.8v3.1h-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.4,83.3c0-.8.2-1.4.6-1.9.4-.5,1-.7,1.7-.7s1.3.2,1.7.7c.4.5.6,1.1.6,1.9v.2c0,.8-.2,1.4-.6,1.9-.4.5-1,.7-1.7.7s-1.3-.2-1.7-.7c-.4-.5-.6-1.1-.6-1.9v-.2ZM44.6,83.4c0,.5.1,1,.3,1.3.2.3.5.5.9.5s.7-.2.9-.5c.2-.3.3-.8.3-1.4s-.1-1-.3-1.3c-.2-.3-.5-.5-.9-.5s-.7.2-.9.5c-.2.3-.3.8-.3,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.2,80.7l0,.6c.4-.5.9-.7,1.5-.7.7,0,1.2.3,1.4.8.4-.5,1-.8,1.6-.8.6,0,1,.2,1.3.5.3.3.4.8.4,1.4v3.5h-1.2v-3.5c0-.3,0-.5-.2-.7-.1-.2-.4-.2-.7-.2-.3,0-.5,0-.7.2-.2.1-.3.3-.4.5v3.7h-1.2v-3.5c0-.3,0-.5-.2-.7-.1-.2-.4-.3-.7-.3-.4,0-.7.2-.9.5v3.9h-1.2v-5.3h1.1Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Table_grid"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 22,
    y: 14,
    width: 54,
    height: 2,
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 22,
    y: 30,
    width: 54,
    height: 2,
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 22,
    y: 46,
    width: 54,
    height: 2,
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 22,
    y: 62,
    width: 54,
    height: 2,
    rx: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 22,
    y: 14,
    width: 2,
    height: 50,
    rx: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 40,
    y: 14,
    width: 2,
    height: 50,
    rx: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 57,
    y: 14,
    width: 2,
    height: 50,
    rx: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 74,
    y: 14,
    width: 2,
    height: 50,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#c8e6c9"
    },
    x: 24,
    y: 16,
    width: 16,
    height: 14,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3f2fd"
    },
    x: 42,
    y: 16,
    width: 15,
    height: 14,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff3e0"
    },
    x: 59,
    y: 16,
    width: 15,
    height: 14,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f3e5f5"
    },
    x: 24,
    y: 32,
    width: 16,
    height: 14,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff8e1"
    },
    x: 42,
    y: 32,
    width: 15,
    height: 14,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e8f5e9"
    },
    x: 59,
    y: 32,
    width: 15,
    height: 14,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e0f7fa"
    },
    x: 24,
    y: 48,
    width: 16,
    height: 14,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fce4ec"
    },
    x: 42,
    y: 48,
    width: 15,
    height: 14,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e8eaf6"
    },
    x: 59,
    y: 48,
    width: 15,
    height: 14,
    rx: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableComponent);
export default __webpack_public_path__ + "static/media/TableComponent.07399b57966706109fb4df85c5c3eb38.svg";
export { ForwardRef as ReactComponent };